import { https } from "@/lib/fetchService";

export interface User {
  id: string;
  email: string;
  name?: string;
  emailVerified: boolean;
  createdAt: string;
  updatedAt: string;
  organizations: {
    id: string;
    name: string;
    role: "owner" | "admin" | "member";
  }[];
}

export interface Session {
  id: string;
  token: string;
  expiresAt: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export interface SessionResponse {
  user: User;
  session: Session;
}

export interface SendOtpParams {
  email: string;
  type: "sign-in" | "email-verification";
}

export interface VerifyOtpParams {
  email: string;
  otp: string;
  type?: "sign-in" | "email-verification";
}

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    name?: string;
  };
}

export const getSession = () =>
  https.get<SessionResponse | null>({ url: "/auth/get-session" });

export const signOut = () => https.post({ url: "/auth/sign-out" });

// Login via otp
export const sendVerificationOtp = (params: SendOtpParams) =>
  https.post({ url: "/auth/email-otp/send-verification-otp", body: params });

export const verifyEmailOtp = (params: VerifyOtpParams) =>
  https.post({ url: "/auth/sign-in/email-otp", body: params });

export const verifyEmailOnlyOtp = (params: VerifyOtpParams) =>
  https.post({ url: "/auth/email-otp/verify-email", body: params });

export interface InvitationResponse {
  id: string;
  organizationId: string;
  organizationName: string;
  organizationSlug: string;
  email: string;
  inviterEmail: string;
  role: string;
  status: "pending" | "accepted" | "rejected" | "canceled";
  expiresAt: string;
  createdAt: string;
}

export const getInvitation = (id: string) =>
  https.get<InvitationResponse>({
    url: "/auth/organization/get-invitation",
    query: { id },
  });

export const acceptInvitation = (invitationId: string) =>
  https.post({
    url: "/auth/organization/accept-invitation",
    body: { invitationId },
  });

export const rejectInvitation = (invitationId: string) =>
  https.post({
    url: "/auth/organization/reject-invitation",
    body: { invitationId },
  });
